import React from "react";
import { FaArrowDown } from "react-icons/fa/";

const Home = props => {
	return (
  	<React.Fragment>
  		<section className = 'hero'>
  			<h1 className='hero-text font-weight-bold text-white text-center'>
  				An Unforgettable Glamping Experience
  			</h1>
				<a href='#bliss-retreat' aria-label="scroll" className='scroll-to-content'>
					<FaArrowDown className='move'/>
				</a>
  		</section>

    		<style jsx='true'>
	    	{`
	    		.hero-text {
	    			font-size: 8vw;
	    			text-shadow: 2px 2px 2px #666;
	    		}

	    		@media screen and (min-width: 1000px) {
	    			.hero-text {
	    				font-size: 4em;
	    			}
	    		}
	    		.hero {
	    			align-items: center;
	    			background: url('/images/hero.jpg');
	    			background-size: cover;
	    			display: flex;
			        flex-flow: column nowrap;
					justify-content: center;
					min-height: calc(100vh - 97px);
					height: 100px;
	    		}
	    		.scroll-to-content {
	    			text-decoration: none;
	    			background: #fff;
	    			width:50px;
	    			height:50px;
	    			text-align:center;
		          	border: 0;
		          	border-radius: 50%;
		          	cursor: pointer;
		          	font-size: 2em;
	    		}

	    		button {
		          background: #fff;
		          border: 0;
		          border-radius: 50%;
		          cursor: pointer;
		          font-size: 2em;
		        }

		        .move {
		        	animation-duration: 1s;
		            animation-name: buttonIconMove;
		            animation-iteration-count: infinite;
		        }

		        @keyframes buttonIconMove {
		          0% {
		            transform: translateY(0);
		          }
		          50% {
		            transform: translateY(-10px);
		          }
		          100% {
		            transform: translateY(0);
		          }
		        }

    		`}</style>
    	</React.Fragment>
    )
}

export default Home